// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.loading_4e02f5c9 {
  display: block;
  border-radius: 50%;
  width: 4.5rem;
  min-width: 4.5rem;
  height: 4.5rem;
  margin: 2.667rem auto;
  border-width: 0.5rem;
  border-style: solid;
  border-color: #dce1e5;
  border-top-color: #26649e;
  opacity: 0;
  animation: spin_4e02f5c9 0.9s cubic-bezier(0.3, 0.18, 0.45, 0.85) infinite forwards, fade_4e02f5c9 2s ease-in 2s forwards;
}
.loading_fast_4e02f5c9 {
  animation: spin_4e02f5c9 0.9s cubic-bezier(0.3, 0.18, 0.45, 0.85) infinite forwards, fade_4e02f5c9 2s ease-in 0s forwards;
}
.loading-holder_4e02f5c9 {
  display: block;
  position: absolute;
  left: 50%;
  top: 50%;
  margin-top: -0.563rem;
  margin-left: -0.5rem;
}
.loading-wrapper_4e02f5c9 {
  display: flex;
}
.loading-wrapper_4e02f5c9 .loading_4e02f5c9 {
  margin: auto;
}
.loading_icon_4e02f5c9 {
  margin: 0;
  opacity: 1;
  animation: spin_4e02f5c9 0.9s cubic-bezier(0.3, 0.18, 0.45, 0.85) infinite forwards;
}
.loading_field-icon_4e02f5c9 {
  margin: 0;
  opacity: 1;
  animation: spin_4e02f5c9 0.9s cubic-bezier(0.3, 0.18, 0.45, 0.85) infinite forwards;
}
.loading_icon_4e02f5c9 {
  border-width: 0.134rem;
  width: 14px;
  min-width: 14px;
  height: 14px;
}
.loading_field-icon_4e02f5c9 {
  border-width: 0.167rem;
  width: 14px;
  min-width: 14px;
  height: 14px;
}
.loading_dark-mode_4e02f5c9 {
  border-color: #fff;
  border-top-color: #a3adb4;
}
@-moz-keyframes spin_4e02f5c9 {
  0% {
    transform: rotateZ(0deg);
  }
  100% {
    transform: rotateZ(360deg);
  }
}
@-webkit-keyframes spin_4e02f5c9 {
  0% {
    transform: rotateZ(0deg);
  }
  100% {
    transform: rotateZ(360deg);
  }
}
@-o-keyframes spin_4e02f5c9 {
  0% {
    transform: rotateZ(0deg);
  }
  100% {
    transform: rotateZ(360deg);
  }
}
@keyframes spin_4e02f5c9 {
  0% {
    transform: rotateZ(0deg);
  }
  100% {
    transform: rotateZ(360deg);
  }
}
@-moz-keyframes fade_4e02f5c9 {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
@-webkit-keyframes fade_4e02f5c9 {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
@-o-keyframes fade_4e02f5c9 {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
@keyframes fade_4e02f5c9 {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"loading": `loading_4e02f5c9`,
	"spin": `spin_4e02f5c9`,
	"fade": `fade_4e02f5c9`,
	"loading_fast": `loading_fast_4e02f5c9`,
	"loading-holder": `loading-holder_4e02f5c9`,
	"loading-wrapper": `loading-wrapper_4e02f5c9`,
	"loading_icon": `loading_icon_4e02f5c9`,
	"loading_field-icon": `loading_field-icon_4e02f5c9`,
	"loading_dark-mode": `loading_dark-mode_4e02f5c9`
};
export default ___CSS_LOADER_EXPORT___;
